import { Component, Input } from '@angular/core';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';

@Component({
    selector: 'agpr-precision-confirm',
    templateUrl: './precision-confirm-dialog.component.html',
    styleUrls: ['./precision-confirm-dialog.component.scss'],
    standalone: false
})
export class PrecisionConfirmDialogComponent extends ConfirmDialogComponent {

    @Input() successCount: number;
    @Input() failedCount: number;

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService);
    }
}
